import {
    OFFER_VIEW,
    ADMINAREA_ACCESS,
    REGIONALDASHBOARD_ACCESS,
    CAPABILITY_GROUP_READ,
    ANNOTATION_READ,
    DYNAMIC_PROFILE_READ,
    SMARTGUARD_ADMIN_VIEW,
    SMARTGUARD_SCOREBOARD_VIEW,
    REDASH_TOOLS_DUPLICATE_DASHBOARD
} from 'constants/capabilities';

exports.SideBarObjects = [
    {
        name: 'Admin',
        type: 'category',
        scope: [ADMINAREA_ACCESS]
    },
    {
        name: 'Entities',
        icon: 'icon-entities',
        path: '/admin/entities',
        type: 'link',
        scope: [ADMINAREA_ACCESS]
    },
    {
        name: 'Users',
        icon: 'icon-user',
        path: '/admin/users',
        type: 'link',
        scope: [ADMINAREA_ACCESS]
    },
    {
        name: 'Brands',
        icon: 'icon-brands',
        path: '/admin/brands',
        type: 'link',
        scope: [REGIONALDASHBOARD_ACCESS, ADMINAREA_ACCESS]
    },
    {
        name: 'Annotations',
        icon: 'icon-annotations',
        path: '/admin/annotations',
        type: 'link',
        scope: [ANNOTATION_READ, ADMINAREA_ACCESS]
    },
    {
        name: 'Offers',
        icon: 'icon-offers',
        path: '/admin/offers',
        type: 'link',
        scope: [OFFER_VIEW, ADMINAREA_ACCESS]
    },
    {
        name: 'Capability Groups',
        icon: 'icon-account-fill',
        path: '/admin/capability-groups',
        type: 'link',
        scope: [CAPABILITY_GROUP_READ, ADMINAREA_ACCESS]
    },
    {
        name: 'Dynamic Profiles',
        icon: 'icon-puzzle-fill',
        path: '/admin/dynamic-profiles',
        type: 'link',
        scope: [DYNAMIC_PROFILE_READ, ADMINAREA_ACCESS]
    },
    {
        name: 'Smartguard',
        icon: 'icon-cog',
        path: '/admin/smartguard/scoreboard',
        type: 'link',
        scope: [SMARTGUARD_ADMIN_VIEW, SMARTGUARD_SCOREBOARD_VIEW, ADMINAREA_ACCESS]
    },
    {
        name: 'Redash Tools',
        icon: 'icon-cog',
        path: '/admin/redash/duplicate',
        type: 'link',
        scope: [REDASH_TOOLS_DUPLICATE_DASHBOARD, ADMINAREA_ACCESS]
    }
];



// WEBPACK FOOTER //
// ./src/components/pages/config/AdminSideBarObjects.js